import { RegisterFormState } from './../models/register.model';
import { PageState } from 'app/store/models/page.model';
import { UserState } from './../models/user.model';
import * as userReducer from './user.reducer';
import * as pageReducer from './page.reducer';
import * as registerReducer from './register.reducer';
import * as messageReducer from './messages.reducer';
import * as meetingReducer from './meeting.reducer';
import * as campaignsReducer from './campaigns.reducer';
import * as datesReducer from './dates.reducer';
import * as productReducer from './product.reducer';
import * as pipelineReducer from './pipeline.reducer';
import { IMessageState } from '../models/message.model';
import { IMeetingState } from '../models/meeting.model';
import { ICampaignState, IBlockedDatesState } from '../models/campaigns.model';
import { IProductState } from '../models/product.model';
import { IPipelineState } from '../models/pipeline.model';

export enum EReducers {
  USER = 'user',
  PAGE = 'page',
  REGISTER = 'register',
  MESSAGE = 'message',
  CAMPAIGNS = 'campaigns',
  BLOCKED_DATES = 'blocked_dates',
  PRODUCT = 'products',
  PIPELINE = 'pipelines',
  MEETING = 'meeting',
}

export interface IReducers {
  user: UserState;
  page: PageState;
  register: RegisterFormState;
  message: IMessageState;
  meeting: IMeetingState;
  campaigns: ICampaignState;
  blocked_dates: IBlockedDatesState;
  products: IProductState;
  pipelines: IPipelineState;
}

export const reducers = {
  user: userReducer.reducer,
  page: pageReducer.reducer,
  register: registerReducer.reducer,
  message: messageReducer.reducer,
  campaigns: campaignsReducer.reducer,
  blocked_dates: datesReducer.reducer,
  products: productReducer.reducer,
  pipelines: pipelineReducer.reducer,
  meeting: meetingReducer.reducer,
};
